export default {
    // 审核状态
    checkStatusList: [
        {
            label: '待审核',
            value: 1,
        },
        {
            label: '已通过',
            value: 2,
        },
        {
            label: '已拒绝',
            value: 3,
        },
    ],
    // 渠道审核状态
    channelCheckStatusList: [
        {
            label: '审批中',
            value: 2,
        },
        {
            label: '已拒绝',
            value: 3,
        },
        {
            label: '已通过',
            value: 4,
        },
    ],
    // 审核节点
    checkNodeList: [
        {
            label: '未开始',
            value: 1,
        },
        {
            label: '待审核',
            value: 2,
        },
        {
            label: '已通过',
            value: 3,
        },
        {
            label: '已拒绝',
            value: 4,
        },
        {
            label: '已转审',
            value: 5,
        },
    ],
    // 所属行业
    industryList: [
        {
            label: '船舶工业',
            value: 0,
        },
        {
            label: '兵器工业/装备',
            value: 1,
        },
        {
            label: '汽车工业',
            value: 2,
        },
        {
            label: '工程机械',
            value: 3,
        },
        {
            label: '电子电器',
            value: 4,
        },
        {
            label: '航空航天',
            value: 5,
        },
        {
            label: '科研院所、高校',
            value: 6,
        },
        {
            label: '轨道交通',
            value: 7,
        },
        {
            label: '其他',
            value: 20,
        },
    ],
    // 商机类型
    businessTypeList: [
        {
            label: '新客户',
            value: 1,
        },
        {
            label: '老客户增购',
            value: 2,
        },
        {
            label: '替换其他品牌',
            value: 3,
        },
    ],
    // 采购方式
    purchaseMethodList: [
        {
            label: '直接采购',
            value: 1,
        },
        {
            label: '招标',
            value: 2,
        },
        {
            label: '其他',
            value: 3,
        },
    ],
    // 成功概率
    successProbabilityList: [
        {
            label: '极高',
            value: 1,
        },
        {
            label: '较高',
            value: 2,
        },
        {
            label: '中等',
            value: 3,
        },
        {
            label: '较低',
            value: 4,
        },
    ],
    // 是否紧急商机选项
    isEmergencyOptions: [
        {
            label: '是',
            value: true,
        },
        {
            label: '否',
            value: false,
        },
    ],
    // 商机状态
    businessStatusList: [
        {
            label: '未开始',
            value: 0,
            style: 'tag-orange',
            disabled: true,
        },
        {
            label: '跟进中',
            value: 1,
            style: 'tag-blue',
        },
        {
            label: '已完成',
            value: 2,
            style: 'tag-green',
        },
        {
            label: '已关闭',
            value: 3,
            style: 'tag-red',
        },
        {
            label: '商机归属方原有关闭',
            value: 4,
            style: 'tag-red',
        },
    ],
    // 负责人类型
    decisionTypeList: [
        {
            label: '决策负责人',
            value: 1,
        },
        {
            label: '技术负责人',
            value: 2,
        },
        {
            label: '采购负责人',
            value: 3,
        },
    ],
    // 关键节点
    keyNodeList: [
        {
            label: '需求确认',
            value: 1,
        },
        {
            label: '方案提交',
            value: 2,
        },
        {
            label: '谈判签约等时间',
            value: 3,
        },
        {
            label: '其他',
            value: 4,
        },
    ],
    // 需要公司支持
    companySupportList: [
        {
            label: '是',
            value: true,
            children: [
                {
                    value: 1,
                    label: '技术演示',
                },
                {
                    value: 2,
                    label: '方案编制',
                },
                {
                    value: 3,
                    label: '客户拜访',
                },
                {
                    value: 4,
                    label: '其他',
                },
            ],
        },
        {
            label: '否',
            value: false,
        },
    ],
    // 客户类型
    customerTypeList: [
        {
            label: '战略客户',
            value: 1,
        },
        {
            label: '普通客户',
            value: 2,
        },
    ],
    // 操作类型
    operationTypeList: [
        {
            label: '新增',
            value: 1,
        },
        {
            label: '编辑',
            value: 2,
        },
        {
            label: '删除',
            value: 3,
        },
        {
            label: '导入',
            value: 4,
        },
        {
            label: '导出',
            value: 5,
        },
    ],
    // 管理员菜单列表
    adminList: [
        {
            name: "数据大屏",
            router: "dataScreen",
            icon: "dataScreen",
        },
        {
            name: "商机管理",
            router: "business",
            icon: "business",
        },
        {
            name: "渠道管理",
            router: "channel",
            icon: "channel",
        },
        {
            name: "跟进报表",
            router: "report",
            icon: "report",
        },
        {
            name: "审核管理",
            router: "approve",
            icon: "approve",
            sub_menus: [
                {
                    name: "商机审核",
                    router: "checkList",
                    icon: "checkList",
                },
                {
                    name: "经销商入驻审核",
                    router: "enterList",
                    icon: "enterList",
                },
            ],
        },
        {
            name: "系统设置",
            router: "setting",
            icon: "setting",
            sub_menus: [
                {
                    name: "参数预设",
                    router: "params",
                    icon: "params",
                },
                {
                    name: "用户管理",
                    router: "user",
                    icon: "user",
                },
            ],
        },
    ],
    // 技术服务菜单列表
    techList: [
        {
            name: "商机管理",
            router: "business",
            icon: "business",
        },
    ],
    // 用户菜单列表
    userList: [
        {
            name: "数据大屏",
            router: "userScreen",
            icon: "userScreen",
        },
        {
            name: "商机管理",
            router: "userBusiness",
            icon: "userBusiness",
        },
        {
            name: "审核管理",
            router: "approve",
            icon: "approve",
            sub_menus: [
                {
                    name: "商机审核",
                    router: "userCheckList",
                    icon: "userCheckList",
                },
            ],
        },
    ],
}